import { ResGetUserInformationPayload } from '@weblite/ts-action/invitation'
import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'

const COLLECTION = 'invitation'
export const invitationStorage = createKeyvalStorage<
  ResGetUserInformationPayload
>(COLLECTION)

export const invitationInfoView = createKeyvalView<
  ResGetUserInformationPayload
>(COLLECTION)
